module.exports = __webpack_public_path__ + "img/c-thermometer-img2-2.71cae520.png";